<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import FloatingButton from "../../floating-button/FloatingButton.vue";
import floppyDisk from "../../../../static/assets/images/floppy-disk.svg";
export default {
  name: "ThatsItTab",
  data() {
    return {
      floppyDisk,
      warmupOptions: [],
      stretchFlowOptions: [],
      warm_up_status: true,
    };
  },
  components: {
    Multiselect,
    FloatingButton,
  },
  computed: {
    ...mapGetters({
      currentActivity: "workouts/currentActivity",
      emotionsOptions: "workouts/emotionsOptions",
      intensityOptions: "workouts/intensityOptions",
      bodyPartsOptions: "workouts/bodyPartsOptions",
      modeOptions: "workouts/modeOptions",
      levelOptions: "workouts/levelOptions",
      benefitsOptions: "workouts/benefitsOptions",
      warmupsOptions: "workouts/warmupsOptions",
      stretchFlowsOptions: "workouts/stretchFlowsOptions",
      cautionsOptions: "workouts/cautionsOptions",
    }),
    emotion: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "emotion",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.emotion;
        }
        return "";
      },
    },
    intensity: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "intensity",
          value,
        });
      },
      get() {
        if (this.currentActivity && this.currentActivity.intensity) {
          return this.currentActivity.intensity;
        }
        return this.getNAdata;
      },
    },
    body_part: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "body_part",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.body_part;
        }
        return "";
      },
    },
    levels: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "levels",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.levels;
        }
        return [];
      },
    },
    levelOptionsRemapped() {
      return this.levelOptions.map((levelOption) => levelOption.value);
    },
    mode: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "mode",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.mode;
        }
        return "";
      },
    },
    benefit_1: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "benefit_1",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.benefit_1;
        }
        return "";
      },
    },
    benefit_2: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "benefit_2",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.benefit_2;
        }
        return "";
      },
    },
    benefit_3: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "benefit_3",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.benefit_3;
        }
        return "";
      },
    },
    cautions: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "cautions",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.cautions;
        }
        return "";
      },
    },
    naz_says: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "naz_says",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.naz_says;
        }
        return "";
      },
    },
    naz_description: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "naz_description",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.naz_description;
        }
        return "";
      },
    },
    need_chapterisation: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "need_chapterisation",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.need_chapterisation;
        }
        return "";
      },
    },
    warm_up: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "warm_up",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.warm_up;
        }
        return "";
      },
    },
    stretch_flow: {
      set(value) {
        this.$store.commit("workouts/setActivityField", {
          fieldName: "stretch_flow",
          value,
        });
      },
      get() {
        if (this.currentActivity) {
          return this.currentActivity.stretch_flow;
        }
        return "";
      },
    },
    getNAdata() {
      var na =  this.intensityOptions.map((res) => {
        if (res.text == "N/A") {
          return res.value;
        }
      });
      return na.join('')
    },
  },
  mounted() {
    this.$store.dispatch(`workouts/getWarmupsOptions`);
    this.$store.dispatch(`workouts/getStretchFlowsOptions`);
  },
  methods: {
    updateActivity() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("workouts/updateActivity", this.$route.params.id)
        .then(
          (res) => {
            this.$store.commit(`commons/setSavingForm`, "Saved");
            this.$store.dispatch(
              `workouts/getCurrentVideos`,
              this.currentActivity.id
            );
            this.tabStatus(false);
            this.$store.commit("commons/setPreloader", false);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    tabStatus(status) {
      this.$store.commit(`workouts/setTabStatus`, status);
    },
  },
  watch: {
    emotion() {
      this.tabStatus(true);
    },
    intensity() {
      this.tabStatus(true);
    },
    body_part() {
      this.tabStatus(true);
    },
    levels() {
      this.tabStatus(true);
    },
    mode() {
      this.tabStatus(true);
    },
    benefit_1() {
      this.tabStatus(true);
    },
    benefit_2() {
      this.tabStatus(true);
    },
    benefit_3() {
      this.tabStatus(true);
    },
    cautions() {
      this.tabStatus(true);
    },
    naz_says() {
      this.tabStatus(true);
    },
    naz_description() {
      this.tabStatus(true);
    },
    need_chapterisation() {
      this.tabStatus(true);
    },
    warm_up() {
      this.tabStatus(true);
    },
    stretch_flow() {
      this.tabStatus(true);
    },
  },
};
</script>

<template>
  <div class="px-5 py-5">
    <b-form>
      <div class="container py-3 pb-5">
        <h2 class="mb-4">Benefits</h2>
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="EMOTION" label-for="emotion" class="select">
              <b-form-select
                v-model="emotion"
                :options="emotionsOptions"
                id="emotion"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              label="INTENSITY"
              label-for="intensity"
              class="select"
            >
              <b-form-select
                v-model="intensity"
                :options="intensityOptions"
                id="intensity"
              ></b-form-select>
            </b-form-group>

            <div class="form-group">
              <label class="d-block">BODY PART</label>
              <multiselect
                v-model="body_part"
                :options="bodyPartsOptions"
                :searchable="true"
                label="text"
                track-by="text"
                :create-tag="true"
                mode="tags"
              >
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label" v-if="value">
                    {{ value.text }}
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group level-dropdown">
              <label class="d-block">LEVEL</label>
              <multiselect
                v-model="levels"
                :options="levelOptionsRemapped"
                mode="tags"
              ></multiselect>
            </div>

            <b-form-group label="MODE" label-for="mode" class="select">
              <b-form-select
                v-model="mode"
                :options="modeOptions"
                id="mode"
              ></b-form-select>
            </b-form-group>
            <div class="form-group">
              <label class="d-block">CAUTION</label>
              <multiselect
                v-model="cautions"
                :options="cautionsOptions"
                label="text"
                track-by="text"
                :create-tag="true"
                mode="tags"
              >
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label" v-if="value">
                    {{ value.text }}
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                <b-form-group
                  label="BENEFIT:"
                  label-for="benefit_1"
                  class="select"
                >
                  <b-form-select
                    v-model="benefit_1"
                    :options="benefitsOptions"
                    id="benefit_1"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group
                  label="BENEFIT:"
                  label-for="benefit_2"
                  class="select"
                >
                  <b-form-select
                    v-model="benefit_2"
                    :options="benefitsOptions"
                    id="benefit_2"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group
                  label="BENEFIT:"
                  label-for="benefit_3"
                  class="select"
                >
                  <b-form-select
                    v-model="benefit_3"
                    :options="benefitsOptions"
                    id="benefit_3"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <b-form-group label="NAZ SAYS" label-for="naz_says">
              <b-form-textarea
                id="naz_says"
                v-model="naz_says"
                placeholder="Enter Naz Says description here..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-form-group label="NAZ DESCRIPTION" label-for="naz_description">
              <b-form-textarea
                id="naz_description"
                v-model="naz_description"
                placeholder="Enter Naz Says description here..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>
      </div>
      <hr />

      <div class="container py-3 pb-5 mb-5">
        <div class="row">
          <div class="col-md-12 mt-5 pb-3">
            <h2>Warm Up & Stretch Flow selection</h2>
            <div class="row mt-4">
              <div class="col-md-2">
                <div class="d-flex">
                  <b-form-radio
                    value="false"
                    v-model="need_chapterisation"
                    class="mr-3 d-flex align-items-center"
                    >None</b-form-radio
                  >
                  <b-form-radio
                    value="true"
                    v-model="need_chapterisation"
                    class="mr-3 d-flex align-items-center"
                    >Yes</b-form-radio
                  >
                </div>
              </div>

              <div class="col-md-3" v-if="need_chapterisation">
                <multiselect
                  v-model="warm_up"
                  :options="warmupsOptions"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :searchable="true"
                  placeholder="Select Warmup"
                  label="text"
                  track-by="text"
                >
                  <template v-slot:singlelabel="{ value }">
                    <div class="multiselect-single-label">
                      {{ value.text }}
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="col-md-3" v-if="need_chapterisation">
                <multiselect
                  v-model="stretch_flow"
                  :options="stretchFlowsOptions"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  :searchable="true"
                  placeholder="Select Stretch flow"
                  label="text"
                  track-by="text"
                >
                  <template v-slot:singlelabel="{ value }">
                    <div class="multiselect-single-label">
                      {{ value.text }}
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <button class="floating-btn btn no-outline" @click="updateActivity()">
      <span class="d-flex justify-content-center align-items-center">
        <img :src="floppyDisk" />
      </span>
    </button>
    <!-- <floating-button> </floating-button> -->
  </div>
</template>
